import i18n from "../../../i8n";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const HorizontalBarChartGraph = ({
    data,
    valueKey = "value",
    height = 400,
    simbolo = "€",
}) => {
    const displayData = Array.isArray(data) ? data : [];

    if (!displayData.length) {
        return (
            <div
                style={{
                    width: "100%",
                    height,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#777",
                    fontSize: "14px",
                }}
            >
                {i18n.t("ui.charts.noData")}
            </div>
        );
    }

    const maxVal = Math.max(
        ...displayData.map((item) => Number(item[valueKey]) || 0),
        0
    );
    const maxTick = Math.max(Math.ceil(maxVal / 500) * 500, 500);
    const ticks = [];
    for (let v = 0; v <= maxTick; v += 500) {
        ticks.push(v);
    }

    return (
        <div
            style={{
                width: "100%",
                height,
                position: "relative",
            }}
        >
            <ResponsiveContainer width="100%" height={height}>
                <BarChart
                    layout="vertical"
                    data={displayData}
                    margin={{ top: 0, right: 24, left: 0, bottom: 70 }}
                >
                    <CartesianGrid
                        horizontal={false}
                        strokeDasharray="3 3"
                        stroke="#f0f0f0"
                    />
                    <XAxis
                        type="number"
                        ticks={ticks}
                        tick={{ fontSize: 15, fill: "#666" }}
                        tickFormatter={(v) => `${v} ${simbolo}`}
                        axisLine={false}
                        tickLine={false}
                        label={{
                            value: `${simbolo} abonados`,
                            position: "bottom",
                            offset: 30,
                            style: {
                                fontSize: 15,
                                fill: "#666",
                                fontWeight: 600,
                            },
                        }}
                    />
                    <YAxis
                        type="category"
                        dataKey="name"
                        width={120}
                        tick={{ fontSize: 15, fill: "#333" }}
                        axisLine={false}
                        tickLine={false}
                    />
                    <Tooltip
                        formatter={(value) => [
                            `${Number(value).toFixed(2)} ${simbolo}`,
                            `${simbolo} abonados`,
                        ]}
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: "14px",
                        }}
                        labelStyle={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "8px",
                        }}
                    />
                    <Bar
                        dataKey={valueKey}
                        fill="#10b981"
                        barSize={14}
                        radius={[0, 6, 6, 0]}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default HorizontalBarChartGraph;
